import React from "react"
import { ManejeIconLoading } from "../ImageComponents"

import "./styles.scss"

export const LoadingIcon = () => {
  return (
    <div id="icon-background" className="background__loading">
      <div className="loading__icon">
        <div className="loading__container">
          <div data-loader="logo-circle"></div>
          <div className="logo__icon">
            <ManejeIconLoading />
          </div>
        </div>
      </div>
    </div>
  )
}

export const Spinner = ({ size, color = "white", label }) => {
  return (
    <div className="loading-spinner-container">
    <div
      className={`loading-spinner ${size && `loading-spinner--${size}`} ${
        color && `loading-spinner--${color}`
      }`}></div>
      {label && <span>{label}</span>}
    </div>
  )
}

export const LoadingWithLabel = ({ labelLoading, sizeSpinner, colorSpinner }) => {
  return (
    <div className="loading-page">
      <Spinner color={colorSpinner || "white"} size={sizeSpinner || "small"} />
      {labelLoading && <h6>{labelLoading}</h6>}
    </div>
  )
}


export const LoadingContainerScreen = () => {
  return (
    <div className="loading-container-screen">
      <div className="loading-container-screen__container">
        <div className="loading-container-screen__icon">
        <LoadingWithLabel labelLoading="Carregando..." sizeSpinner="large" colorSpinner="primary" />
        </div>
      </div>
    </div>
  )
}